import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router'
import { injectIntl, defineMessages } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fields } from '../../common/lib/redux-fields'
import formValidation from '../../common/lib/formValidation'
import { validateCreateTranslation } from '../../common/lessons/validations'
import { wordTranslate, clearSuggestion,
  wordAutocomplete, clearAutocomplete } from '../../common/lessons/actions'
import { updateMe } from '../../common/users/actions'
import { exerciseTypes, hasAutocomplete, languages } from '../../common/config'
import { LessonFormHeader } from '../forms'
import { Popup, withNameInput, Button, TextInput, SelectInput } from '../components'


class TranslationForm extends React.Component {
  constructor(props) {
    super(props)
    this.wordFields = []
    
    this.state = {
      wordlist: this.wordFields,
      languages: {
        baseLang: (props.viewer && props.viewer.userLanguage) || 'en',
        foreignLang: (props.viewer && props.viewer.foreignLanguage) || 'es',
      },
      languagesList: Object.keys(languages).map(key =>
        ({ key, label: languages[key].name })),
      isPublic: true,
      lastUpdatedId: null,
      showForeignSuggestion: false,
      showTranslationSuggestion: false,
    }

    this.handleWordChange = this.handleWordChange.bind(this)
  }

  componentDidMount() {
    const { lesson } = this.props

    if (!lesson) {
      for (let i = 0; i < 5; i += 1) {
        this.wordFields.push(
          { base: '', foreign: [''], id: i, maxPoints: 1 },
        )
      }
      this.setState({ wordlist: this.wordFields })
    } else {
      const foreignLang = lesson.foreignLang
      const words = lesson.words.map(word => ({
        base: word.baseWord,
        foreign: word.foreignWord,
        maxPoints: word.maxPoints || 1,
      }))
      this.setState({
        id: lesson.id,
        wordlist: words,
        languages: {
          baseLang: lesson.baseLang,
          foreignLang,
        },
        isPublic: lesson.isPublic,
      })
    }
  }

  componentWillUnmount() {
    const { fields, clearSuggestion, clearAutocomplete } = this.props
    fields.$reset()
    clearSuggestion()
    clearAutocomplete()
  }

  async submitForm(e) {
    e.preventDefault()
    const { fields, submit, history, isTestForm, hideForm } = this.props
    const { languages, wordlist, id, isPublic } = this.state
    let words = wordlist.filter(word => word.base && word.foreign)

    words = words.map(word => ({
      ...word,
      base: word.base.trim(),
      foreign: word.foreign.map(w => w.trim()),
      maxPoints: parseFloat(word.maxPoints ? word.maxPoints.toString().replace(',', '.') : 1),
    }))

    const values = {
      ...fields.$values(),
      id,
      baseLang: languages.baseLang,
      foreignLang: languages.foreignLang,
      words,
      isPublic,
      type: exerciseTypes.TRANSLATION,
    }
    if (await submit(values) !== false) {
      fields.$reset()
      if (isTestForm) {
        hideForm()
      } else {
        history.push('/app/lessons')
      }
    }
  }

  handleWordChange(newWord, idx, type, fidx = 0) {
    const { wordAutocomplete, clearAutocomplete, clearSuggestion } = this.props
    const { languages } = this.state

    const newWordlist = this.state.wordlist.map((word, sidx) => {
      if (idx !== sidx) return word
      if (type === 'base') return { ...word, base: newWord }
      const newForeign = word.foreign.map((foreignWord, fid) => {
        if (fidx !== fid) return foreignWord
        return newWord
      })
      return { ...word, foreign: newForeign }
    })
    this.setState({ wordlist: newWordlist, lastUpdatedId: idx })

    /*
    const langAutocomplete = hasAutocomplete.includes(languages.foreignLang)

    if (newWord.length > 2 && langAutocomplete) {
      wordAutocomplete(newWord, languages.foreignLang)
    } else if (type === 'foreign') {
      clearAutocomplete()
      clearSuggestion()
    }
    */
  }

  handlePointsChange = idx => e => {
    const newWordlist = this.state.wordlist.map((word, sidx) => {
      if (idx !== sidx) return word
      return { ...word, maxPoints: e.target.value }
    })
    this.setState({ wordlist: newWordlist })
  }

  handleAddCorrectAnswer(idx) {
    const newWordlist = this.state.wordlist.map((word, sidx) => {
      if (idx !== sidx) return word
      return { ...word, foreign: [...word.foreign, ''] }
    })
    this.setState({ wordlist: newWordlist, lastUpdatedId: idx })
  }

  handleRemoveCorrectAnswer(idx, fidx) {
    const newWordlist = this.state.wordlist.map((word, sidx) => {
      if (idx !== sidx) return word
      const newForeign = word.foreign.filter((_, fid) => fid !== fidx)
      return { ...word, foreign: newForeign }
    })
    this.setState({ wordlist: newWordlist, lastUpdatedId: idx })
  }

  handleAddWord = (e) => {
    e.preventDefault()
    const newWordlist = this.state.wordlist.concat([
      { base: '', foreign: [''] }])

    this.setState({
      wordlist: newWordlist,
    })
  }

  handleRemoveWord(e, idx) {
    const { wordlist } = this.state
    e.preventDefault()
    this.setState({
      wordlist: wordlist.filter((_, sidx) => idx !== sidx),
    })
  }

  handleChangeLang(e, base) {
    const { languages } = this.state

    if (base === 'base') {
      this.setState({
        languages: {
          ...languages,
          baseLang: e.target.value,
        },
      })
    } else {
      this.setState({
        languages: {
          ...languages,
          foreignLang: e.target.value,
        },
      })
    }
  }

  suggestTranslation(idx, word) {
    const { wordTranslate } = this.props
    const { languages, wordlist } = this.state
    const { base, foreign } = wordlist[idx]
    
    const translateWord = word || foreign

    if (foreign.length > 1 && !base.length) {
      wordTranslate(translateWord, languages.foreignLang, languages.baseLang)
    }
  }

  render() {
    const { viewer, lesson, updateMe, fields, translationSuggest,
      clearSuggestion, clearAutocomplete, isDetailPage, errorMessage, intl,
      wordSuggestions } = this.props
    const { languagesList, languages, wordlist, showTranslationSuggestion,
      lastUpdatedId, showForeignSuggestion } = this.state

    return (
      <div className="float-left width-full">
        {
          !isDetailPage && (viewer && !viewer.seenGuides.translationDescription) &&
          <Popup
            title={intl.formatMessage(messages.popupTitle)}
            text={intl.formatMessage(messages.popupContent)}
            onClick={() => updateMe({ seenGuides: { translationDescription: true } })}
          />
        }
        <form className="flex-column" onSubmit={(e) => this.submitForm(e)}>
          <LessonFormHeader
            isDetailPage={isDetailPage}
            errors={errorMessage}
            fields={fields}
            lesson={lesson}
            instructions={intl.formatMessage(messages.defaultInstructions)}
          />
          <div className="translation-languages-selection">
            <SelectInput
              value={languages.foreignLang}
              label={intl.formatMessage(messages.foreignLanguage)}
              options={languagesList}
              onChange={(e) => this.handleChangeLang(e, 'foreign')}
              disabled={isDetailPage}
            />
            <SelectInput
              value={languages.baseLang}
              label={intl.formatMessage(messages.matureLanguage)}
              options={languagesList}
              onChange={(e) => this.handleChangeLang(e, 'base')}
              disabled={isDetailPage}
            />
          </div>
          {
            wordlist.map((word, idx) => (
              <div className="item-box lesson-word" key={idx}>
                <span className="order-num">
                  {idx + 1}
                </span>
                <div className="lesson-word-col">
                  {
                    word.foreign.map((foreignWord, fidx) => (
                      <div className="row">
                        <TextInput
                          placeholder={intl.formatMessage(messages.foreignPlaceholder)}
                          value={foreignWord}
                          onChange={(e) => {
                            this.handleWordChange(e.target.value, idx, 'foreign', fidx)
                            this.setState({ showForeignSuggestion: true })
                          }}
                          className="translation-word-input"
                          disabled={isDetailPage}
                        />
                        {
                          fidx > 0 && !isDetailPage &&
                          <span
                            key={`${idx}-${fidx}`}
                            className="delete-icon spacing-left"
                            onClick={() => {
                              this.handleRemoveCorrectAnswer(idx, fidx)
                            }}
                          >
                            <FontAwesomeIcon icon="trash" />
                          </span>
                        }
                      </div>
                    ))
                  }
                  {
                    !isDetailPage &&
                    <Button
                      className="disable-spacing-left vertical-spacing"
                      positive
                      onClick={() => {
                        this.handleAddCorrectAnswer(idx)
                      }}
                    >
                      {intl.formatMessage(messages.addCorrectAnswer)}
                    </Button>
                  }
                  {
                    idx == lastUpdatedId && wordSuggestions && showForeignSuggestion &&
                    <ul className="lesson-word-suggestions">
                      {
                        wordSuggestions.slice(0,10).map(aWord => (
                          <li
                            key={aWord}
                            onClick={() => { 
                              this.handleWordChange(aWord, idx, 'foreign')
                              this.setState({
                                  showForeignSuggestion: false,
                                  showTranslationSuggestion: true,
                              })
                              clearSuggestion()
                              this.suggestTranslation(idx, aWord)
                            }}
                          >
                            {aWord}
                          </li>
                        ))
                      }
                    </ul>
                  }
                </div>
                <div className="lesson-word-col">
                  <TextInput
                    // label={intl.formatMessage(messages.questionLabel)}
                    placeholder={intl.formatMessage(messages.definitionPlaceholder)}
                    value={word.base}
                    onChange={(e) => this.handleWordChange(e.target.value, idx, 'base')}
                    onFocus={() => {
                      clearAutocomplete()
                      this.setState({ showTranslationSuggestion: true })
                      this.suggestTranslation(idx)
                    }}
                    className="translation-word-input"
                    disabled={isDetailPage}
                  />
                  {
                    idx == lastUpdatedId && translationSuggest && showTranslationSuggestion &&
                    <ul className="lesson-word-suggestions">
                      {
                        translationSuggest.slice(0,10).map(aWord => (
                          <li
                            key={aWord}
                            onClick={() => { 
                              this.handleWordChange(aWord, idx, 'base')
                              clearSuggestion()
                              this.setState({ showTranslationSuggestion: false })
                            }}
                          >
                            {aWord}
                          </li>
                        ))
                      }
                    </ul>
                  }
                </div>
                {/*
                  viewer && viewer.role === roles.TEACHER &&
                  <TextInput
                    className="points-input"
                    type="text"
                    name={`points${idx}`}
                    value={word.maxPoints}
                    onChange={this.handlePointsChange(idx)}
                    label={intl.formatMessage(messages.points)}
                    disabled={isDetailPage}
                  />
                */}
                {
                  !isDetailPage ?
                    <span className="delete-icon" onClick={(e) => this.handleRemoveWord(e, idx)}>
                      <FontAwesomeIcon icon="trash" />
                    </span>
                  :
                    <span>&nbsp;</span>
                }
              </div>
            ))
          }
          {
            !isDetailPage &&
            <React.Fragment>
              <div className="item-box">
                <div className="block-center">
                  <Button onClick={this.handleAddWord}>
                    {intl.formatMessage(messages.addWord)}
                  </Button>
                </div>
              </div>
              <div className="float-left block-center bottom-save-button">
                <Button big positive type="submit">
                  {intl.formatMessage(messages.save)}
                </Button>
              </div>
            </React.Fragment>
          }
        </form>
      </div>
    )
  }
}

TranslationForm.defaultProps = {
  isDetailPage: false,
  viewer: null,
  lesson: null,
  translationSuggest: '',
}

TranslationForm.propTypes = {
  intl: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  viewer: PropTypes.object,
  lesson: PropTypes.object,
  isDetailPage: PropTypes.bool,
  updateMe: PropTypes.func.isRequired,
  wordAutocomplete: PropTypes.func.isRequired,
  clearAutocomplete: PropTypes.func.isRequired,
  wordTranslate: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  clearSuggestion: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  errorMessage: PropTypes.any.isRequired,
  translationSuggest: PropTypes.string,
}

TranslationForm = withRouter(TranslationForm)

const enhance = compose(
  // withNameInput,
  formValidation(props => ({
    validationFunc: validateCreateTranslation,
    submitFunc: props.submitLesson,
  })),
  connect(state => ({
    viewer: state.users.viewer,
    translationSuggest: state.lessons.translationSuggest,
    wordSuggestions: state.lessons.wordSuggestions,
  }), { updateMe, wordTranslate, clearSuggestion,
    wordAutocomplete, clearAutocomplete }),
  fields({
    path: 'TranslationForm',
    fields: [
      'name', 'instructions', 'prologueText', 'youtubeVideo', 'subject', 'tags',
    ],
    getInitialState: ({ lesson, viewer, ...props }) => ({
      name: (lesson && lesson.name) || props.name || '',
      instructions: ((lesson && lesson.instructions)
        ? lesson.instructions : ''),
      prologueText: (lesson && lesson.prologueText) || props.prologueText || '',
      youtubeVideo: (lesson && lesson.youtubeVideo) || props.youtubeVideo || '',
      tags: (lesson && lesson.tags) || props.tags || [],
      subject: (lesson && lesson.subject) || props.subject || ((viewer && viewer.subjects.length && !lesson)
        ? viewer.subjects[0] : ''),
    }),
  }),
  injectIntl,
)

export default enhance(TranslationForm)

const messages = defineMessages({
  popupTitle: {
    id: 'translation.form.popupTitle',
    defaultMessage: 'Inštrukcie',
  },
  defaultInstructions: {
    id: 'translation.form.defaultInstructions',
    defaultMessage: 'Východzie: Preložte následujúce výrazy',
  },
  popupContent: {
    id: 'translation.form.popupContent',
    defaultMessage: 'Vložte naľavo výrazy alebo otázky a napravo správne odpovede, ktoré bude aplikácia po vyplnení žiakmi kontrolovať.',
  },
  matureLanguage: {
    id: 'translation.form.matureLanguage',
    defaultMessage: 'Rodný jazyk',
  },
  foreignLanguage: {
    id: 'translation.form.foreignLanguage',
    defaultMessage: 'Cudzí jazyk',
  },
  leftColumnTitle: {
    id: 'translation.form.leftColumnTitle',
    defaultMessage: 'Stĺpec, ktorý uvidia žiaci',
  },
  rightColumnTitle: {
    id: 'translation.form.rightColumnTitle',
    defaultMessage: 'Stĺpec, ktorý budú vypĺnať žiaci',
  },
  questionLabel: {
    id: 'translation.form.questionLabel',
    defaultMessage: 'Výraz v rodnom jazyku / Otázka:',
  },
  definitionPlaceholder: {
    id: 'translation.form.definitionPlaceholder',
    defaultMessage: 'Zadajte Váš preklad',
  },
  answerLabel: {
    id: 'translation.form.answerLabel',
    defaultMessage: 'Výraz v cudzom jazyku/Odpoveď:',
  },
  foreignPlaceholder: {
    id: 'translation.form.foreignPlaceholder',
    defaultMessage: 'Zadajte výraz v cudzom jazyku',
  },
  addCorrectAnswer: {
    id: 'translation.form.addCorrectAnswer',
    defaultMessage: 'Pridať synonymum',
  },
  points: {
    id: 'translation.form.points',
    defaultMessage: 'Body:',
  },
  addWord: {
    id: 'translation.form.addWord',
    defaultMessage: 'Pridať výraz',
  },
  save: {
    id: 'translation.form.save',
    defaultMessage: 'Uložiť',
  },
})



// WEBPACK FOOTER //
// ./src/browser/forms/TranslationForm.js